module.exports = __webpack_public_path__ + "img/7.d060f930.png";